import axios from "axios";
import qs from "qs";
import { AppApiURL } from "../helpers/apiUrl";
import {
  apiErrorResponseInterceptor,
  apiResponseInterceptor,
  authCredentialsRequestInterceptor,
  genericErrorInterceptor,
  languageRequestInterceptor,
} from "./interceptors";

export type AxiosResponse = {
  // `data` is the response that was provided by the server
  data: { [key: string]: any };

  // `status` is the HTTP status code from the server response
  status: number;

  // `statusText` is the HTTP status message from the server response
  statusText: string;

  // `headers` the HTTP headers that the server responded with
  // All header names are lower cased and can be accessed using the bracket notation.
  // Example: `response.headers['content-type']`
  headers: {};

  // `config` is the config that was provided to `axios` for the request
  config: {};

  // `request` is the request that generated this response
  // It is the last ClientRequest instance in node.js (in redirects)
  // and an XMLHttpRequest instance in the browser
  request: {};
};

let Axios: any = axios.create({
  baseURL: AppApiURL.fullUrl,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": AppApiURL.allowedOrigins.join(","),
    "Content-Type": "application/json",
    "Accept-Language": "en",
  },
  responseType: "json",
  paramsSerializer: serializeParams,
});

// The following interceptor will inject the needed auth headers into each request we make
Axios.interceptors.request.use(
  authCredentialsRequestInterceptor,
  genericErrorInterceptor
);

// The following interceptor will inject the needed language headers into each request we make
Axios.interceptors.request.use(
  languageRequestInterceptor,
  genericErrorInterceptor
);

// The following interceptor will handle the parsing the response and error handling
Axios.interceptors.response.use(
  apiResponseInterceptor,
  apiErrorResponseInterceptor
);

function serializeParams(params: any) {
  return qs.stringify(params, { arrayFormat: "brackets" });
}

export default Axios;
